import * as React from "react";

function CartIcon(props) {
  return (
    <svg
      width={32}
      height={31}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.01 15.057h15.852c.464 0 .929-.332.995-.796l2.918-10.215a1.024 1.024 0 00-.994-1.327H6.305l-.398-1.525C5.708.464 5.045 0 4.382 0H1.728C.866 0 .07.663.004 1.526c-.066.928.73 1.724 1.592 1.724H3.12l5.041 17.047c.2.73.796 1.194 1.526 1.194h18.705c.862 0 1.658-.664 1.724-1.526.066-.929-.73-1.725-1.592-1.725h-16.45c-.729 0-1.326-.464-1.525-1.127v-.066c-.332-.995.464-1.99 1.46-1.99zM12.34 30.046a2.653 2.653 0 100-5.306 2.653 2.653 0 000 5.306zM25.274 30.046a2.653 2.653 0 100-5.306 2.653 2.653 0 000 5.306z"
        fill="#fff"
      />
    </svg>
  );
}

export default CartIcon;